<div class="inbox-header">
  <h2 *ngIf="content?.title">{{ content.title }}</h2>
  <a class="button button--secondary inbox-header__back" *ngIf="activeMessage" (click)="activeMessage = undefined">
    <i class="icon icon icon-ui-arrow--left"></i>
    <span>{{ "general.label.back" | translate }}</span>
  </a>
</div>
<ng-container *ngIf="!isLoading; else loading">
  <ng-container *ngIf="isInboxEnabled; else disabled">
    <div class="inbox" *ngIf="messages.length > 0; else noMessages">
      <air-inbox-message-list
        [ngClass]="{ 'inbox-message-list--selected': activeMessage }"
        [messages]="messages"
        [activeMessage]="activeMessage"
        (activeMessageId)="setActiveMessage($event)"
        (deleteMessageId)="deleteMessage($event)"
        (manage)="setIsManage($event)"
      ></air-inbox-message-list>
      <div class="inbox__message" [ngClass]="{ 'inbox__message--inactive': isManage, 'inbox__message--unselected': !activeMessage }">
        <air-inbox-message-view
          *ngIf="activeMessage; else noActiveMessage"
          [message]="activeMessage"
          (deleteMessageId)="deleteMessage($event)"
        ></air-inbox-message-view>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #loading>
  <div class="inbox loading">
    <div></div>
    <div></div>
  </div>
</ng-template>
<ng-template #disabled>
  <span [internalInnerHtml]="content.disabledDescription" [userEventSource]="userEventSource"></span>
</ng-template>
<ng-template #noMessages>
  <p>{{ "inbox.label.no_messages" | translate }}</p>
</ng-template>
<ng-template #noActiveMessage>
  <span class="inbox__select-message">{{ "inbox.label.select_message" | translate }}</span>
</ng-template>
